export default __webpack_public_path__ + "static/media/section33.03e8c685.svg";